// @givmo/employer-module — bring a block a money dialog has just shown into view (EP-WEB34; Company
// Profiles' 2026-10-03 review, P5).
//
// A money dialog taller than the screen scrolls inside itself (the design system clamps it to the
// viewport). The close acknowledgement a maybe-charged Cancel shows replaces the footer at the very
// bottom, so on a phone it opens below the fold, and with it the only two ways forward. `block:
// 'nearest'` scrolls only as far as the block needs, and not at all where it is already in view. The
// block carries the dialog's bottom padding as its scroll margin (`scroll-mb-24`, the popup's `p-24`),
// so it lands where scrolling to the end by hand does, never on the card's clipped edge.

import { useEffect, useRef } from 'react';

/** A ref for a block that is scrolled into view each time it is shown (`shown` turns true). */
export function useRevealOnShow<T extends HTMLElement>(shown: boolean) {
  const ref = useRef<T>(null);
  useEffect(() => {
    if (!shown) return;
    // jsdom lays nothing out, so it has no `scrollIntoView`.
    ref.current?.scrollIntoView?.({ block: 'nearest' });
  }, [shown]);
  return ref;
}
